import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { bulkUpdateToCart } from './bulkUpdateToCart';
import { addRenewalsToCart } from '../subscription-management/renewals/addRenewalsToCart';
import { SOURCE_CATALOGUE } from '../../store/constants';
import { useNotification } from '../../app-store/notification/useNotification';

export const useAddRenewalsToCart = () => {
    const { t } = useTranslation();
    const [isLoading, setLoading] = useState(false);
    const { showNotificationWithInfo } = useNotification();

    return {
        isLoading,
        addToCartBulk: (totalValue: number, performChecks: boolean) => {
            const apiCallback = () => addRenewalsToCart(totalValue, performChecks);

            return bulkUpdateToCart({
                setLoading,
                performChecks,
                source: SOURCE_CATALOGUE,
                apiCallback,
                t,
                onSuccess: () => {},
                productSelection: undefined,
                showNotificationWithInfo
            });
        }
    };
};
